import styled from 'styled-components';
import { TextField } from '@mui/material';

import {
    getColor,
    getFontFamily,
    getFontSize,
    getLetterSpacing, getLineHeight,
} from '@process-advisor/process-miner/shared/theme';
//    width: 350px;
export const Text = styled(TextField)<{ width: string, height?: string }>`

    width: ${({ width }) => width};
    & .MuiInputBase-root {
        height: ${({ height }) => height};
        background-color: ${getColor('white')};
        border: 1px solid ${getColor('lightBorderColor')};
        border-radius: 8px;
        font-size: ${getFontSize('small')} !important;
        &:hover {
            border-color: ${getColor('blue')};
        }
    }

    & .MuiInputBase-root.Mui-disabled {
        background-color: ${getColor('lightGray')};

        &:hover {
            border-color: ${getColor('lightBorderColor')};
        }
    }

    & .MuiInputBase-root.MuiOutlinedInput-root {
        padding: 10px !important;
    }

    & input {
        text-align: left;
        padding: 10px !important;
        color: ${getColor('inputTextColor')};
        font-family: ${getFontFamily('atlassian')};
        font-size: ${getFontSize('smaller')} !important;
        letter-spacing: ${getLetterSpacing('input')};
        line-height: ${getLineHeight('small')};
    }
    & fieldset,
    & fieldset:hover {
        border: none;
    }

`;
